import React, {useMemo} from 'react';

import {Button, BUTTON_STYLES} from '@/components/base/button/Button';
import {Typography, VARIANTS} from '@/components/base/typography/Typography';
import Image from '@/components/common/image/Image';
import {Section, SECTION_STYLES} from '@/components/common/section/Section';
import {useRequestForm} from '@/components/page/meetings/hooks/useRequestForm';
import {useMediaQueryMatch} from '@/hooks/use-media-query-match';
import {Media, MediaContextProvider} from '@/media';
import {typography} from '@/utilites/typography/typography';

import Img from './assets/promo_img_3x.webp';
import styles from './Promo.module.css';

export function Promo() {
	const {handleOpenDialog} = useRequestForm();
	const [isDesktop] = useMediaQueryMatch('(min-width: 1440px)');

	const desc = useMemo(() => {
		if (isDesktop) {
			return (
				<>
					Сервис сбора обратной связи
					<br />
					от&nbsp;сотрудников
				</>
			);
		}

		return <>{typography('Сервис сбора обратной связи от сотрудников')}</>;
	}, [isDesktop]);

	return (
		<Section style={SECTION_STYLES.WITH_BREAKPOINTS} className={styles.root}>
			<div className={styles.textBlock}>
				<Typography variant={VARIANTS.h1} className={styles.title}>
					Опросы
				</Typography>
				<Typography variant={VARIANTS.text} className={styles.subTitle}>
					{desc}
				</Typography>
				<div className={styles.btnContainer}>
					<Button
						className={styles.button}
						style={BUTTON_STYLES.PRIMARY}
						onClick={handleOpenDialog}
					>
						{typography('Подключить')}
					</Button>
				</div>
			</div>

			<div className={styles.imageWrapper}>
				<MediaContextProvider>
					<Media className={styles.imgItem} lessThan="desktop">
						<Image src={Img} alt={'Promo'} layout="responsive" />
					</Media>
					<Media className={styles.imgItem} at="desktop">
						<Image src={Img} alt={'Promo'} width={391} height={344} layout="fixed" />
					</Media>
					<Media className={styles.imgItem} greaterThanOrEqual="desktop_xl">
						<Image src={Img} alt={'Promo'} width={580} height={510} layout="fixed" />
					</Media>
				</MediaContextProvider>
			</div>
		</Section>
	);
}
